import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ReportingService } from '../_service/reporting.service';
import { InventoryService } from '../_service/inventory.service';
import type { EChartsOption } from 'echarts';
import { getInstanceByDom, connect } from 'echarts';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [NgbModule, RouterModule, CommonModule, FormsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, AfterViewInit {

  totalSales: any = {};
  reportingSrvs = inject(ReportingService)
  modal = inject(NgbModal)
  invetorySrvs = inject(InventoryService)
  router = inject(Router)
  inventories: any = signal('');
  salesHistory: any;
  inventoryService = inject(InventoryService)
  activityLogs: any;
  cartValue: number = 0; // New property to store cart value

  // Loading states
  isLoadingSummary = false;
  isLoadingOrders = false;
  isLoadingWaiters = false;
  isLoadingLogs = false;
  isLoadingInventory = false;

  // Filter properties
  dateFilter = 'all'; // Default filter - show all time
  showDatePicker = false;
  customStartDate = '';
  customEndDate = '';

  page = 1
  size = 0
  pageSize = 1
  page2 = 10
  categories: any;
  selectedOrder: any = null;
  options: any = {};

  salesChart: any;
  totalItems: any;
  currentPage: any;
  pendingOrders: any;
  activeWaiters: any;

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   const chartElement1: any = document.getElementById('chart1');
    //   const chartElement2: any = document.getElementById('chart2');
    //   const chart1: any = getInstanceByDom(chartElement1);
    //   const chart2: any = getInstanceByDom(chartElement2);
    //   connect([chart1, chart2]);
    // });
  }

  ngOnInit(): void {
    this.getSalesSummary()
    this.fetchPendingOrders();
    this.fetchActiveWaiters();
    this.getSalesChart()
    this.listInventory()
    this.viewActivityLogs()
  }
  getTotalOrderAmount(): number {
    if (!this.selectedOrder || !this.selectedOrder.order_items) {
      return 0;
    }
    return this.selectedOrder.order_items.reduce((total: any, item: any) => total + (parseFloat(item.amount) * item.quantity), 0);
  }
  public closeModal(): void {
    this.modal.dismissAll();
  }
  openOrderDetails(order: any, content:any) {
    this.selectedOrder = order;
    const modalRef = this.modal.open(content, { size: 'lg' });
  }
  getSalesSummary() {
    this.isLoadingSummary = true;
    const filterParams = this.getFilterParams();
    this.reportingSrvs.salesSummary(filterParams).subscribe({
      next: (data) => {
        this.totalSales = data;
        console.log('totalSales with filters:', this.totalSales, 'filters:', Object.keys(filterParams).length > 0 ? filterParams : 'All time (no filters)');
        this.isLoadingSummary = false;
      },
      error: (error) => {
        console.error('Error fetching sales summary:', error);
        this.isLoadingSummary = false;
      }
    });
  }

  // Filter methods
  setDateFilter(filter: string) {
    this.dateFilter = filter;
    this.showDatePicker = filter === 'custom';
    if (filter !== 'custom') {
      this.refreshData();
    }
  }

  applyCustomDate() {
    if (this.customStartDate && this.customEndDate) {
      this.refreshData();
    }
  }

  getFilterParams() {
    const params: any = {};

    // If 'all' is selected, return empty params to show all-time data
    if (this.dateFilter === 'all') {
      return params;
    }

    const now = new Date();
    let startDate: Date | undefined, endDate: Date | undefined;

    switch (this.dateFilter) {
      case 'today':
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        break;
      case 'week':
        const weekStart = new Date(now);
        weekStart.setDate(now.getDate() - now.getDay());
        startDate = weekStart;
        endDate = now;
        break;
      case 'month':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = now;
        break;
      case 'custom':
        if (this.customStartDate && this.customEndDate) {
          startDate = new Date(this.customStartDate);
          endDate = new Date(this.customEndDate);
        }
        break;
      default:
        return params;
    }

    if (startDate && endDate) {
      params.start_date = startDate.toISOString().split('T')[0];
      params.end_date = endDate.toISOString().split('T')[0];
    }

    return params;
  }

  refreshData() {
    this.getSalesSummary();
    this.fetchPendingOrders();
    this.fetchActiveWaiters();
    this.viewActivityLogs();
  }
  fetchPendingOrders() {
    this.isLoadingOrders = true;
    this.inventoryService.fetchPendingOrders().subscribe({
      next: (res: any) => {
        this.pendingOrders = res.data;
        console.log('Pending Orders', this.pendingOrders);
        this.isLoadingOrders = false;
      },
      error: (error) => {
        console.error('Error fetching pending orders:', error);
        this.isLoadingOrders = false;
      }
    });
  }

  fetchActiveWaiters() {
    this.isLoadingWaiters = true;
    this.inventoryService.fetchActiveWaiters().subscribe({
      next: (res: any) => {
        this.activeWaiters = res.data;
        console.log('Active Waiters', this.activeWaiters);
        this.isLoadingWaiters = false;
      },
      error: (error) => {
        console.error('Error fetching active waiters:', error);
        this.isLoadingWaiters = false;
      }
    });
  }
  viewActivityLogs(page: number = 1) {
    this.isLoadingLogs = true;
    this.inventoryService.activityLogs(page).subscribe({
      next: (response: any) => {
        this.activityLogs = response.data;
        this.totalItems = response.meta.total;
        this.currentPage = response.meta.current_page;
        this.pageSize = response.meta.per_page;
        this.isLoadingLogs = false;
      },
      error: (err) => {
        console.error('Error fetching activity logs:', err);
        this.isLoadingLogs = false;
      },
      complete: () => {
      }
    });
  }
  getSalesChart() {
    this.reportingSrvs.salesChart().subscribe({
      next: (res: any) => {
        this.salesChart = res
        this.options = {
          color: ['#00a859'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            left: '0%',
            right: '0%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: 'Orders',
              type: 'bar',
              barWidth: '60%',
              data: this.convertObjectToArray(res.monthly_orders),
            },
          ],
        };
      }, error: (err) => {
        console.log(err)
      }

    })
  }
  convertObjectToArray(data: any[]) {
    // Assuming data is an array of objects
    return Object.values(data);
  }
  getCurrentYear(): number {
    const currentYear = new Date().getFullYear();
    return currentYear;
  }
  listInventory() {
    this.isLoadingInventory = true;
    this.invetorySrvs.listInventories().subscribe({
      next: (res: any) => {
        // Sort the data by quantity before setting it
        const sortedData = res.data.sort((a: any, b: any) => a.quantity - b.quantity);
        this.inventories.set(sortedData);
        const meta = res.meta;
        this.size = meta.total;
        this.pageSize = meta.per_page;
        this.isLoadingInventory = false;
      },
      error: (error) => {
        console.error('Error fetching inventory:', error);
        this.isLoadingInventory = false;
      }
    });
  }

  addInv() {
    this.router.navigateByUrl('/admin/inventory')
  }

  updateCartValue() {
    // Logic to update the cart value based on this.salesChart
    if (this.salesChart && Array.isArray(this.salesChart)) {
      // Assuming this.salesChart.data contains the relevant cart information
      this.cartValue = this.salesChart.reduce((acc: number, value: number) => acc + value, 0);
      console.log('Updated cart value:', this.cartValue);
    }
  }
  closeOrder(orderId: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to close this order?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.inventoryService.closeOrder(orderId).subscribe({
          next: (response) => {
            Swal.fire(
              'Closed!',
              'Order has been closed.',
              'success'
            );
            this.closeModal();
            this.fetchPendingOrders(); // Refresh the pending orders list
          },
          error: (error) => {
            Swal.fire(
              'Error!',
              'Failed to close the order.',
              'error'
            );
          }
        });
      }
    });
  }

  // Method to determine if a number should use smaller font
  isLongNumber(value: any): boolean {
    if (!value) return false;
    const stringValue = value.toString().replace(/[^\d]/g, ''); // Remove non-digits
    return stringValue.length > 8; // Consider numbers with more than 8 digits as long
  }

  // Method to get appropriate CSS class for number length
  getNumberClass(value: any): string {
    return this.isLongNumber(value) ? 'long-number' : '';
  }
}
